export const SWAP = "/";
export const LIQUIDITY = "/liquidity";
